import type { LiftQuestion, Question } from '@tbd/simcapture-api-types';

export const sortQuestions = (questions: Question[]) => {
  questions.sort((a, b) => a.sortOrder - b.sortOrder);
  questions.forEach((q) => q.answerOptions.sort((a, b) => a.sort - b.sort));
};

// TODO: Update ResponseBreakdown type and reference here
export const sortResponseBreakdown = (responseBreakdown: LiftQuestion[]) => {
  responseBreakdown.sort((a, b) => a.questionSortOrder - b.questionSortOrder);
  responseBreakdown.forEach((question) =>
    question.answerOptions.sort(
      (a, b) => a.answerOptionSort - b.answerOptionSort
    )
  );
};

export const sortOrganizationPicklist = (organizations: { name: string }[]) => {
  return organizations.sort((a, b) => a.name.localeCompare(b.name));
};

export function sortUsersByFirstName(
  users: Array<{ firstName: string }>
): Array<{ firstName: string }> {
  return users.sort((a, b) => a.firstName.localeCompare(b.firstName));
}

type MaybeHasSortPosition = { sortPosition?: number };
export const compareBySortPositionAscending = (
  a: MaybeHasSortPosition,
  b: MaybeHasSortPosition
) => {
  const aSortPosition = a.sortPosition ?? Number.MAX_SAFE_INTEGER;
  const bSortPosition = b.sortPosition ?? Number.MAX_SAFE_INTEGER;
  if (aSortPosition < bSortPosition) {
    return -1;
  }
  if (aSortPosition > bSortPosition) {
    return 1;
  }
  return 0;
};
